import { useFormik } from "formik";
import {
  Box,
  Button,
  Flex,
  Text,
  FormControl,
  FormLabel,
  Input,
  VStack
} from "@chakra-ui/react";
import { useAuth } from "../../providers/AuthProvider";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const { login } = useAuth();
  const [error, setError] = useState();

  const [info, setinfo] = useState(null);

  const navigate = useNavigate();


  const formik = useFormik({

    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: async (values) => {
      // alert(JSON.stringify(values, null, 2));

      setinfo("Logging in...");
      var res = await login(values.email, values.password);
      setinfo(null);
      if (res === "err") {
        setError("Invalid Credentials !");
      } else {
        navigate('/');
      }

    }

  });

  return (
    <Flex align="center" justify="center" color='#fefefe' maxH="100%" minH="100vh" bg='primary.800'>
      <Box p={6} maxW={'500px'} w='90%'>
        <form onSubmit={formik.handleSubmit}>
          <VStack spacing={4} align="flex-start">

            <img src='/logo-white.png' width='256px' alt='Logo' />

            <Text fontSize='2xl' as='h3'>Login to Continue</Text>

            {error ? <Box bg='red' w='100%' py='1' textAlign='center' color='white' > {error} </Box> : <></>}
            {info && <Text color='white'>{info}</Text>}
            <FormControl>
              <FormLabel htmlFor="email">Email</FormLabel>
              <Input
                id="email"
                name="email"
                type="text"
                variant="outline"
                required={true}
                onChange={formik.handleChange}
                value={formik.values.email}
                />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor="password">Password</FormLabel>
              <Input
                id="password"
                name="password"
                type="password"
                required={true}
                variant="outline"
                onChange={formik.handleChange}
                value={formik.values.password}
              />
            </FormControl>
            <Button type="submit" bg="white" color='#1c1c1c' _hover={{ bg: 'primary.700' }}  py='6' width="full">
              Login
            </Button>
          </VStack>
        </form>
      </Box>
    </Flex>
  );
}